<template>
    <v-flex xs12>
      <v-card>
        <v-flex xs12 px-4 v-if="err">
          <v-alert :value="true" type="error">{{err}}</v-alert>
        </v-flex>
        <v-card-title class="py-3 px-2 layout row wrap">
          <v-btn class="primary my-0 mx-3" @click='$router.push({ name: "callerIdCreate" })'>{{$lang.actions.createCallerId}}</v-btn>
          <v-checkbox
            color="primary"
            class="mx-1 mt-0"
            :label="$lang.labels.showActive"
            v-model="showActive"
            hide-details
           />
          <v-spacer />
          <v-autocomplete
            class="min-w max-w mx-3 pb-2"
            :label="$lang.actions.selectCompany"
            :items="mappedCompanies"
            v-model="selectedCompany"
            hide-details
          />
          <v-text-field
            v-if="show"
            class="min-w max-w mx-3 pb-2"
            v-model="search"
            append-icon="search"
            :label="$lang.labels.search"
            hide-details
          />
        </v-card-title>
        <v-data-table
          v-if="show"
          :headers="headers"
          :items="showActive ? activeCallerIdServers : allCallerIdServers"
          :search="search"
          :loading="loading"
          :rows-per-page-items="[50, 100, 250, 500, { text:'All' , value: -1 }]"
        >
          <v-progress-linear height="6" slot="progress" color="primary" indeterminate />
          <template slot="items" slot-scope="props">
            <td>{{ props.item.name }}</td>
            <td>{{ props.item.status }}</td>
            <td class="min-w-lg">
              <v-btn class="primary mx-0 elevation-1" @click="$router.push({ name: 'callerIdEdit', params: { id: props.item.id } })">{{$lang.actions.edit}}</v-btn>
              <v-btn class="primary elevation-1" @click="changeStatus(props.item)">{{props.item.status === 'active' ? $lang.actions.deactivate : $lang.actions.activate}}</v-btn>
            </td>
          </template>
          <v-alert slot="no-results" :value="true" color="warning" icon="warning">
            Your search for "{{ search }}" found no results.
          </v-alert>
        </v-data-table>
      </v-card>
    </v-flex>
</template>

<script>
  export default {
    data() {
      return {
        err: '',
        loading: false,
        show: false,
        selectedCompany: null,
        companies: [],
        search: '',
        headers: [
          {text: this.$lang.header.callerIdName, value: 'name', align: 'left',},
          {text: this.$lang.labels.status, value: 'status', align: 'left',},
          {text: this.$lang.labels.actions, value: 'actions', align: 'left', sortable: false,},
        ],
        showActive: true,
        allCallerIdServers: [],
      };
    },
    methods: {
      changeStatus(callerId) {
        const action = callerId.status === 'active' ? 'deactivate' : 'activate';
        this.$http.post(`calleridserver/${action}/${callerId.id}`)
        .then((res) => {
          if (res.body.status === 'Success') {
            this.$set(callerId, 'status', action === 'activate' ? 'active' : 'inactive');
            return;
          }
          this.err = res.body.statusText;
        }, (err) => {
          this.err = err.body.statusText || err.body.message;
        });
      },
      fetchCallerIDforCompany(id) {
        this.loading = true;
        this.allCallerIdServers = [];
        this.activeCallerIdServers = [],
        this.$http.post('calleridserver', {companyId: id})
        .then((res) => {
          if (res.body.status === 'Success') {
            this.loading = false;
            this.allCallerIdServers = res.body.details;
            if (this.allCallerIdServers.length === 0){
              this.loading = false;
            }
            return;
          }
          this.err = res.body.statusText;
        }, (err) => {
          this.loading = false;
          this.err = err.body.statusText || err.body.message;
        });
      },
    },
    watch: {
      err(val) {
        if (val !== '') {
          setTimeout(() => { this.err = ''; }, 5000);
        }
      },
      selectedCompany(val) {
        this.show = true;
        this.fetchCallerIDforCompany(val);
        this.$cookie.set('companyedit', val, { expires: '8h' });
      },
    },
    computed: {
      activeCallerIdServers() {
        const callerIdServers = this.allCallerIdServers;
        const activeCallerIdServers = [];
        for (let i=0; callerIdServers.length > i; i++) {
          if (callerIdServers[i].status === 'active') {
            activeCallerIdServers.push(callerIdServers[i]);
          }
        }
        return activeCallerIdServers;
      },
      mappedCompanies() {
        return this.companies.map(company => ({
          text: `${company.name} (${company.companyStatus})`,
          value: company.id,
        }));
      },
    },
    created() {
      this.$http.get('company')
        .then((res) => {
          if (res.body.status === 'Success') {
            this.companies = res.body.companies;
            return;
          }
          this.err = res.body.statusText;
        }, (err) => {
          this.err = err.body.statusText || err.body.message;
        });
      const edit = this.$cookie.get('companyedit');
      if (edit) this.selectedCompany = edit;
    },
  };
</script>



// WEBPACK FOOTER //
// CallerIdServers.vue?7c45b9b3